import { render } from "./TypeCategoriesView.vue?vue&type=template&id=709f3050&scoped=true"
import script from "./TypeCategoriesView.vue?vue&type=script&lang=js"
export * from "./TypeCategoriesView.vue?vue&type=script&lang=js"

import "./TypeCategoriesView.vue?vue&type=style&index=0&id=709f3050&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-709f3050"]])

export default __exports__